import React, { useEffect, useState } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { useParams, Link } from "react-router-dom";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import RectLoader from "../../components/loaders/Rectangle";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import translations from "../../translations/skill.json";
import "./skill.scss";
import { getSkillPage } from "../../services/verifiedBackendService/skill";

const Skill = (props) => {
	props.addTranslation(translations);

	const { skillId } = useParams();
	const [loading, setLoading] = useState(false);
	const [skillTitle, setSkillTitle] = useState("");
	const [skillDescription, setSkillDescription] = useState("");
	const [relatedSkills, setRelatedSkills] = useState([]);
	const [skillsWithDescription, setSkillsWithDescription] = useState([]);

	useEffect(() => {
		getSkillData();
	}, [skillId]);

	const getSkillData = async () => {
		setLoading(true);
		const skillPageResponse = await getSkillPage(skillId);
		setSkillTitle(skillPageResponse.result.title);
		setSkillDescription(skillPageResponse.result.description.description);
		setRelatedSkills(skillPageResponse.result.relateds);
		setSkillsWithDescription(skillPageResponse.skillsWithDescription);
		setLoading(false);
	};

	return (
		<div id="skill-main" className="flex-row jc-c">
			<div className="skill-inside flex-column ai-c">
				<h1 className="s-title s4-5 boldish">
					<Translate id="skillDetails" />
				</h1>
				{loading ? (
					<div className="flex-column ai-c">
						<div
							style={{
								width: props.isMobile ? "300px" : "400px",
								height: "30px",
								marginBottom: "15px",
							}}
						>
							<RectLoader
								width={props.isMobile ? 300 : 400}
								height={30}
								radius={19}
							/>
						</div>
						<div
							style={{
								width: props.isMobile ? "350px" : "660px",
								height: "90px",
							}}
						>
							<RectLoader
								width={props.isMobile ? 350 : 660}
								height={90}
								radius={19}
							/>
						</div>
					</div>
				) : (
					<div className="flex-column ai-c">
						<OverlayTrigger
							placement={"bottom"}
							overlay={
								<Tooltip
									style={{
										maxWidth: "400px",
									}}
								>
									{skillTitle}
								</Tooltip>
							}
						>
							<span id="skill-title" className="s5 boldish">
								{skillTitle}
							</span>
						</OverlayTrigger>
						<span className="skill-desc s6">{skillDescription}</span>
					</div>
				)}

				<div className="related-skills flex-column ai-c">
					<span className="s-title s4-5 boldish">
						<Translate
							id="exploreMoreSimilar"
							data={{
								skillName: skillTitle,
							}}
						/>
					</span>
					{loading ? (
						<div className="skill-container flex-row jc-c">
							<div
								style={{
									width: "90px",
									height: "38px",
									borderRadius: "18px",
									marginRight: "20px",
									marginBottom: "20px",
								}}
							>
								<RectLoader width={90} height={38} radius={19} />
							</div>
							<div
								style={{
									width: "120px",
									height: "38px",
									borderRadius: "19px",
									marginRight: "20px",
									marginBottom: "20px",
								}}
							>
								<RectLoader width={120} height={38} radius={19} />
							</div>
							<div
								style={{
									width: "250px",
									height: "38px",
									borderRadius: "19px",
									marginRight: "20px",
									marginBottom: "20px",
								}}
							>
								<RectLoader width={250} height={38} radius={19} />
							</div>
						</div>
					) : (
						<div className="skill-container flex-row jc-c">
							{relatedSkills.map((skill) =>
								skillsWithDescription.includes(skill.id) ? (
									<Link
										to={`/${
											props.activeLanguage ? props.activeLanguage.code : "en"
										}/skill/${skill.id}/`}
									>
										<BaseButton
											className="single-skill"
											type="secondary"
											size="small"
											loading={false}
											height={38}
										>
											<span>{skill.title}</span>
										</BaseButton>
									</Link>
								) : (
									<BaseButton
										className="single-skill"
										type="secondary"
										size="small"
										loading={false}
										height={38}
										disabled
									>
										<span>{skill.title}</span>
									</BaseButton>
								)
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default withLocalize(Skill);
